import React, { useState,useRef, useEffect } from "react";
import { useNavigate} from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { useForm} from "react-hook-form";
import { ToastContainer, toast} from 'react-toastify';
import AsyncSelect from 'react-select/async';
import axios from 'axios';

import authHeader from "../../../services/auth-header";
import { API } from "../../../backend";
import TableRow from '../../../components/TableRow/temp';

import AddInvoiceService from "../../../services/billing/createInvoiceService";
var tableRowIndex = 0;

function CreateInvoices1() {
const [due_date,setDue_Date] = useState(null);
const [total_amount,setTotal_Amount] = useState("");
const [notes,setNotes] = useState("");
const [comments,setComments] = useState("");
const [billing_address,setBillingAddress] = useState("");
const [talbeRows, setRows] = useState([{
    index: 0,
    first_name: "",
    last_name: ""
 }
]);
const [successful, setSuccessful] = useState(false);
const checkBtn = useRef();
const { register, handleSubmit ,formState:{errors} } = useForm();
const form = useRef();
const [selectedValue,setSelectedValue] = useState(null);
const [inputvalue,setValue] = useState("");

const [selectedValue2,setSelectedValue2] = useState(null);
const [inputvalue2,setValue2] = useState("");

// Receive data from TableRow 
const handleChange = data => {
    talbeRows[data.index] = data
 }

 // Add New Table Row
 const addNewRow = () => {
    tableRowIndex = parseFloat(tableRowIndex) + 1
    var updatedRows = [...talbeRows]
    updatedRows[tableRowIndex] = {index: tableRowIndex, first_name: "", last_name: ""}
    setRows(updatedRows)
 }

 const deleteRow = (index) => {
    if(talbeRows.length > 1){
        var updatedRows = [...talbeRows]
        var indexToRemove = updatedRows.findIndex(x => x.index === index);
        if(indexToRemove > -1){
            updatedRows.splice(indexToRemove, 1)
            setRows(updatedRows);
        }
    }
 }


const handelInputChange2 = (value1)=>{
    setValue2(value1);
}
const handelChange2 = (value1) =>{
    setSelectedValue2(value1)

    
}
const loadOptions2 = async (inputValue2) => {
    const response = await axios.get(
        API+`contracts/contracts/filter/${inputValue2}`, {headers: authHeader() }
        
    );
    return response.data.data
};

const handelInputChange = (value)=>{
    setValue(value);
}
const handelChange1 = (value) =>{
    setSelectedValue(value)
}
const loadOptions = async (inputValue) => {
    const responseJSON = await axios.get(
        API+`parties/party/?customer_name=${inputValue}`, {headers: authHeader() }
        
    );
    return responseJSON.data.data
};
const getAddress = async () => {
    const responseJSON = await axios.get(
        API+`contracts/contract-getAddress/${selectedValue2.contract_number}/`, {headers: authHeader() }
        
    );
    return setBillingAddress(responseJSON.data.address_name)
};

useEffect(()=>{
    getAddress()
},[selectedValue2])

const navigate = useNavigate()

const handleRegister = () => {

setSuccessful(false);

    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
        AddInvoiceService.addInvoice(
        selectedValue2.id,
        due_date.toISOString().split('T')[0],
        comments,
        notes,
        ).then(
        (response) => {
            if (response.data.success){
            setSuccessful(true);
            setTimeout(()=>{
                navigate("/billing")
            },2000)
            toast.success(`${response.data.response}`)
            }
            else{
            toast.error(`${response.data.error}`)
            setSuccessful(false);
            }
        },
        )
    }
}


  return (

    <div className="page-wrapper">
    <ToastContainer/>
        <div className="content container-fluid">
            <div className="row">
                <div className="col-md-12">
                    <div className="card mb-0">
                        <div className="card-header pb-0">
                            <div className="d-lg-flex">
                                <div>
                                <h5 className="mb-0">Create Invoice</h5>										
                                </div>                               
                            </div>
                        </div>					
                <div className="show_invoice">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="success"></div>
                                    <Form  role="form text-left"
                                        onSubmit={handleSubmit(handleRegister)}
                                        ref={form}
                                        action="."
                                        method="POST" 
                                        id="addPartyForm" >
                                        {(
                                            <>
                                    <input type="hidden" value="" id="invoiceid" name="invoiceid"/>
                                    <input type="hidden" value="" id="invoiceno" name="invoiceno"/>
                                    <div className="row">
                                        <div className="col-xl-6">
                                            <div className="form-group row">
                                                <label className="col-lg-3 col-form-label">Customer Name</label>
                                                <div className="col-lg-9">
                                                    <AsyncSelect 
                                                defaultOptions
                                                isClearable
                                                value={selectedValue}
                                                getOptionLabel={e=>e.customer_name}
                                                getOptionValue={e=>e.customer_name}
                                                loadOptions={loadOptions}   
                                                onInputChange={handelInputChange}
                                                onChange={handelChange1}
                                                >
                                                
                                                    
                                                </AsyncSelect> 
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-6">
                                            <div className="form-group row">
                                                <label className="col-lg-4 col-form-label">Contract Number</label>
                                                <div className="col-lg-9">
                                                    <AsyncSelect 
                                                defaultOptions
                                                isClearable
                                                value={selectedValue2}
                                                getOptionLabel={e=>e.contract_number}
                                                getOptionValue={e=>e.contract_number}
                                                loadOptions={loadOptions2}   
                                                onInputChange={handelInputChange2}
                                                onChange={handelChange2}
                                                >
                                                
                                                    
                                                </AsyncSelect>
                                                    <input type="hidden" id="contract_status" value='Active' />
                                                </div>
                                            </div>
                                        </div>											
                                        <div className="col-xl-6">
                                            <div className="form-group row">
                                                <label className="col-lg-3 col-form-label">Bill to Address</label>
                                                <div className="col-lg-9">
                                                    <span id="bill_to">{billing_address}</span>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="row">    
                                        <div className="col-xl-6">
                                            <div className="form-group row">
                                                <label className="col-lg-3 col-form-label">Due Date</label>
                                                <div className="col-lg-9">
                                                <DatePicker
                                                className="form-control datepick"
                                                selected={due_date}
                                                onChange={(date) => setDue_Date(date)}
                                                placeholderText={"dd/mm/yyyy"}
                                                filterDate={(date) => date.getDay() !== 6 && date.getDay() !== 0} // weekends cancel
                                                showYearDropdown // year show and scrolldown alos
                                                scrollableYearDropdown
                                            

                                                />
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="row">    
                                            <div className="col-xl-6">
                                                <div className="form-group row">
                                                    <label className="col-lg-3 col-form-label">Invoice Amount</label>
                                                    <div className="col-lg-9">
                                                        <input disabled readonly type="text" className="form-control"  name="invoice_amount" id="invoice_amount" 
                                                        onChange={(e)=>setTotal_Amount(e.target.value)} />
                                                    </div>
                                                </div>
                                            </div>
                                            </div>

                                    <div className="row">
                                        <div className="col-xl-6">
                                            <div className="form-group row">
                                                <label className="col-lg-3 col-form-label">Description</label>
                                                <div className="col-lg-9">
                                                    <textarea className="form-control" id="description" name="description"  
                                                    onChange={(e)=>setComments(e.target.value)}></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                              
                                    <div className="row">
                                        <div className="col-xl-6">
                                            <div className="form-group row">
                                                <label className="col-lg-3 col-form-label">Notes</label>
                                                <div className="col-lg-9">
                                                    <textarea className="form-control" id="description" name="notes" 
                                                    onChange={(e)=>setNotes(e.target.value)}></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                              
                                    <div className="customers">
       <table className="table" id="customers">
         <thead>
            <tr>
               <th>ID</th>
               <th>Name</th>
               <th></th>
            </tr>
          </thead>
          <tbody>
               {
                  talbeRows.map((row, index) => {
                     if(row)
                     return(
                        <TableRow key={index} row={row} handleDataChange={handleChange} deleteRow={deleteRow}></TableRow>
                     )
                  })
               }
          </tbody>
       </table>
       <div>
          <button className="btn-add" onClick={addNewRow}>+Add</button>
       </div>
    </div>
                                </>
                                )}
                                    <CheckButton style={{ display: "none" }}  ref={checkBtn} />            
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>        
    </div>
</div>
  )
}

export default CreateInvoices1
